import gql from 'graphql-tag'
import assign from 'lodash/assign'
import clone from 'lodash/clone'
import base from 'app/queries/base'

export default {

    all: function(options={}){

        return assign(clone(base), {

            query: gql`
                query AllLoggers($offset: Int, $limit: Int, $filter: LoggerFilter, $search: String, $sortField: LoggerSortField, $sortDirection: SortDirection, $allocationProjectIds: [ID], $repairIds: [ID]) {
                    viewer {
                        allLoggers(offset: $offset, limit: $limit, filter: $filter, search: $search, sortField: $sortField, sortDirection: $sortDirection, allocationProjectIds: $allocationProjectIds, repairIds: $repairIds) {
                            totalCount
                            items {
                                id
                                typeId
                                owner
                                state
                                serialNumber
                                purchaseDate
                                purchaseValue
                                documentReference
                                comments
                                createdAt
                                type {
                                    id
                                    title
                                }
                                activeAllocation {
                                    id
                                    startDate
                                    endDate
                                    actionDeadline
                                    project {
                                        id
                                        title
                                        code
                                        projectManager
                                        actionDeadline
                                    }
                                }
                                activeRepair {
                                    id
                                    reference
                                }
                                latestMutation {
                                    id
                                    data
                                }
                            }
                        }
                    }
                }`,

            variables(){

                return {
                    offset: null,
                    limit: null,
                    filter: {},
                    search: null,
                    sortField: null,
                    sortDirection: null,
                    allocationProjectIds: null,
                    repairIds: null
                }
            },

            update: ({viewer}) => viewer.allLoggers

        }, options);
    },

    allSummary: function(options={}){

        return assign(clone(base), {

            query: gql`
                query AllLoggers($offset: Int, $limit: Int, $filter: LoggerFilter, $search: String, $sortField: LoggerSortField, $sortDirection: SortDirection, $allocationProjectIds: [ID], $repairIds: [ID]) {
                    viewer {
                        allLoggers(offset: $offset, limit: $limit, filter: $filter, search: $search, sortField: $sortField, sortDirection: $sortDirection, allocationProjectIds: $allocationProjectIds, repairIds: $repairIds) {
                            totalCount
                            items {
                                id
                                typeId
                                owner
                                state
                                serialNumber
                                purchaseDate
                                purchaseValue
                                createdAt
                                type {
                                    id
                                    title
                                }
                                activeAllocation {
                                    id
                                    projectId
                                    project {
                                        id
                                        actionDeadline
                                    }
                                }
                            }
                        }
                    }
                }`,

            variables(){

                return {
                    offset: null,
                    limit: null,
                    filter: {},
                    search: null,
                    sortField: null,
                    sortDirection: null,
                    allocationProjectIds: null,
                    repairIds: null
                }
            },

            update: ({viewer}) => viewer.allLoggers

        }, options);
    },

    find: function(options={}){

        return assign(clone(base), {

            query: gql`
                query FindLogger($loggerId: ID!, $mutationSortField: LoggerMutationSortField, $mutationSortDirection: SortDirection) {
                    viewer {
                        findLogger(id: $loggerId) {
                            id
                            typeId
                            owner
                            state
                            serialNumber
                            purchaseDate
                            purchaseValue
                            documentReference
                            comments
                            createdAt
                            type {
                                id
                                title
                            }
                            activeAllocation {
                                id
                                startDate
                                endDate
                                actionDeadline
                                project {
                                    id
                                    title
                                    code
                                    projectManager
                                    actionDeadline
                                    munisenseGroupId
                                }
                            }
                            openActions {
                                itemCount
                            }
                            actions(sortField: issueDate, sortDirection: DESC) {
                                itemCount
                                items {
                                    id
                                    state
                                    categories
                                    issueDate
                                    commentsOffice
                                    project {
                                        id
                                        code
                                        projectManager
                                    }
                                }
                            }
                            loggerMutations(sortField: $mutationSortField, sortDirection: $mutationSortDirection) {
                                items {
                                    id
                                    type
                                    data
                                    comments
                                    createdAt
                                }
                            }
                        }
                    }
                }`,

            update: ({viewer}) => viewer.findLogger

        }, options);
    },

    findBySerialNumber: function(options={}){

        return assign(clone(base), {

            query: gql`
                query FindLoggerBySerial($serialNumber: String!) {
                    viewer {
                        findLoggerBySerialNumber(serialNumber: $serialNumber) {
                            id
                            typeId
                            owner
                            state
                            serialNumber
                            purchaseDate
                            purchaseValue
                            createdAt
                            type {
                                id
                                title
                            }
                            activeAllocation {
                                id
                                projectId
                                project {
                                    id
                                    actionDeadline
                                }
                            }
                        }
                    }
                }`,

            update: ({viewer}) => viewer.findLoggerBySerialNumber

        }, options);
    }
}